import { render, staticRenderFns } from "./gridIndustrial.vue?vue&type=template&id=1b99805e&"
import script from "./gridIndustrial.vue?vue&type=script&lang=js&"
export * from "./gridIndustrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports